<div class="wrapper-carousel" [class.is-gradient-no-widget]="!hasWidgets">
  <div class="content">
    <div class="slider">
      <div class="slides"
        #carouselContent
        (scroll)="onScroll($event)">
        <div class="img-cont" 
          *ngFor="let image of images; index as id;" 
          [id]="id"
          (click)="callDeeplink(image, id)">
          <app-image 
            [type]="typeImageFlight"
            [src]="image | imageDesktopOrMobile | async">
          </app-image>
        </div>
      </div>
    </div>
    <div class="gallery-dots">
      <ng-container *ngFor="let dot of dots; let i = index;">
        <div class="gallery-dot"
             (click)="moveCarouselByDot(i)"
             *ngIf="dots?.length > 1">
          <div class="dot-progress"
            *ngIf="i === currentPosition"
            [style.width.%]="dotPercentaje"></div>
        </div>
      </ng-container>
    </div>
  </div>
</div>